import React from 'react';
import AltIso from 'alt/utils/AltIso';
import _ from 'lodash';

import connectToStores from 'alt/utils/connectToStores';

import ShiftPositionsForm from '../forms/ShiftPositionsForm'

import CandidateStore from '../stores/CandidateStore';
import PositionStore from '../stores/PositionStore';
import ShiftStore from '../stores/ShiftStore';

@AltIso.define((props) => {
    return Promise.all([
        PositionStore.getPositions()
    ]);
})

@connectToStores
class EditShiftPosition extends React.Component {

    constructor(props) {
        super(props);
    }

    static getPropsFromStores() {
        return {
            candidateStore: CandidateStore.getState(),
            positionStore: PositionStore.getState(),
            shiftStore: ShiftStore.getState()
        };
    }

    static getStores() {
        return [PositionStore, ShiftStore, CandidateStore];
    }

    componentDidMount() {
        const shift = this.props.shift;
        this.props.onChange(this.preparePositionData(shift, this.props.positionStore.positions), this.refs.form.validate(true).errors, 2);

        CandidateStore.getPotentialCandidates(shift.position_id, shift.rate);
    }

    preparePositionData(shift, positions) {
        let curShift = {};
        if (shift.position_id) {
            curShift.position = shift.position_id.toString();
        }
        curShift.status = shift.status;
        curShift.workers_needed = shift.workers_needed;
        const default_pay = _.result(_.find(positions, pos => {
            return pos.id == shift.position_id;
        }), 'default_pay');
        const maxDeg = 187;
        const minDeg = -17;
        const bestPay = default_pay*2;
        const rate = shift.rate;
        let degrees = 0;
        let text = '';
        if (bestPay == 0 || rate/bestPay <= 0) {
            degrees = minDeg;
            text = 'Hourly rate too low';
        } else if (rate / bestPay >= 1) {
            degrees = maxDeg + minDeg;
            text = 'Awesome hourly rate!';
        } else {
            degrees = (rate / bestPay)*maxDeg - 17;
            if(degrees < 36) {
                text = 'Hourly rate too low';
            } else if (degrees < 109) {
                text = 'Hourly rate is average';
            } else {
                text = 'Awesome hourly rate!';
            }
        }
        curShift.rate = rate;
        curShift.dresscode = shift.dresscode;
        curShift.degrees = degrees;
        curShift.meterText = text;
        curShift.minWorkers = shift.candidates_hired;
        curShift.positionDescription = _.result(_.find(positions, position => {
            return position.id == shift.position_id;
        }), 'description');

        return curShift;
    }

    onChange(value, path) {
        const errors = this.refs.form.validate(true, value).errors;
        const changed = !!value.rate;
        this.props.onChange(value, errors, 2, changed);

        if (path.indexOf('position') > -1 || path.indexOf('rate') > -1) {
            CandidateStore.getPotentialCandidates(value.position, value.rate);
        }
    }

    render () {
        const shift = this.props.shift || {position: {}};
        const positions = this.props.positionStore.positions;

        return (
            <div className={"edit-shift-position" + (this.props.isActive ? " active" : "")}>
                <div className="position-form-content">
                    <form noValidate>
                        <ShiftPositionsForm
                            disabled={this.props.disabled}
                            initialFormData={this.preparePositionData(shift, positions)}
                            errors={this.props.shiftStore.createError}
                            onChange={this.onChange.bind(this)}
                            ref="form"
                            positions={positions}
                            potentialCandidates={this.props.candidateStore.potentialCandidates} />
                    </form>
                </div>
            </div>
        );
    }
}

export default EditShiftPosition;



/** WEBPACK FOOTER **
 ** ./app/src/components/EditShiftPosition.js
 **/